import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEquipmentStandard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 70 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8623 16.3344L20.5979 1.52979L37.3336 16.3344V50.1275H3.8623V16.3344Z",
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0684 15.3686L20.4362 7.96631L28.804 15.3686V21.3226H12.0684V15.3686Z",
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.28711 18.862L20.5975 1.52979L39.9078 18.862",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.41406,
			y: 31.1392,
			width: 4.02299,
			height: 14.1609,
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.5859,
			y: 31.1392,
			width: 4.02299,
			height: 14.1609,
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.7588,
			y: 31.1392,
			width: 4.02299,
			height: 14.1609,
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 37.333,
			y: 31.1392,
			width: 28.8046,
			height: 18.9885,
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70 50.1274H0",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.5518,
			y: 38.2197,
			width: 8.36782,
			height: 11.908,
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.333 31.1392H68.7123L64.8503 23.4955H37.333V31.1392Z",
			fill: "white",
			stroke: "#808080",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgEquipmentStandard);
export default ForwardRef;
